
<div class="text-left d-inline-flex indicor-bg " [ngStyle]="{'background-color': corIndicador}"></div><span class="sub-titulo"> {{ titulo }} <span class="dados-qtd"> {{ valor }} </span></span>
<div class="text-left d-flex flex-column  ms-4 ">
    <p class="dados-qtd"><span class="simbolos"> % </span> {{ dados.porcetagem | number:'1.2-2' }} </p>
    <p class="dados-qtd"><span class="simbolos"> Kg </span>  {{ dados.peso | number:'1.2-2' }} </p>
    <p class="dados-qtd"><span class="simbolos"> R$ </span> {{ dados.valor | number:'1.2-2'  }}</p>
</div>
